import type { NotificationPreferences } from '@central/api';
import { NotificationPreferencesCard, type NotificationCategory } from '@central/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keys, useApi } from '../api';

/** The signed-in staff user's own email notification switches. */
export function NotificationPrefs() {
  const api = useApi();
  const queryClient = useQueryClient();
  const prefs = useQuery({
    queryKey: keys.notificationPrefs,
    queryFn: () => api.notificationPrefs.get(),
  });
  const save = useMutation({
    mutationFn: ({ key, on }: { key: NotificationCategory; on: boolean }) =>
      api.notificationPrefs.update({ [key]: on }),
    onSuccess: (p: NotificationPreferences) => queryClient.setQueryData(keys.notificationPrefs, p),
  });
  return (
    <NotificationPreferencesCard
      prefs={prefs.data}
      loadError={prefs.error ?? undefined}
      saving={save.isPending ? save.variables?.key : undefined}
      saveError={save.error ?? undefined}
      onChange={(key, on) => save.mutate({ key, on })}
    />
  );
}
